import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types';

const ShowAlarm = ({ alarm }) => {
  if (alarm <= 0) {
    return null
  }
  return (
    <div className="new-fleet-info__train__header__events--alarm">
      <span>Alarms</span>
      <div className="new-fleet-info__train__header__events--circle new-fleet-info__status-red">
        <span>{alarm}</span>
      </div>
    </div>
  )
}
export default ShowAlarm